import { FC } from "react";
import Chip from "@mui/material/Chip";

const COLORS: Record<string, { bg: string; label: string }> = {
	ACTIVE: { bg: "#1D9E75", label: "Active" },
	COMPLETED: { bg: "#7F77DD", label: "Completed" },
	DISENROLLED: { bg: "#D85A30", label: "Disenrolled" },
	PAUSED: { bg: "#888780", label: "Paused" },
};

interface StatusChipProps {
	status: string;
}

const StatusChip: FC<StatusChipProps> = ({ status }) => {
	const entry = COLORS[status] ?? { bg: "#888780", label: status };
	return (
		<Chip
			label={entry.label}
			size="small"
			sx={{
				bgcolor: entry.bg,
				color: "#fff",
				fontWeight: 600,
				minWidth: 100,
			}}
		/>
	);
};

export default StatusChip;
